import { render, staticRenderFns } from "./NoticeSetting.vue?vue&type=template&id=38e8fef2&scoped=true&"
import script from "./NoticeSetting.vue?vue&type=script&lang=js&"
export * from "./NoticeSetting.vue?vue&type=script&lang=js&"
import style0 from "./NoticeSetting.vue?vue&type=style&index=0&id=38e8fef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8fef2",
  null
  
)

export default component.exports